import {formatPriceWithCurrency, resolveCurrencyLocale, type SupportedCurrency} from "../shared/utils/priceFormatting";

export const outputPriceWithCurrency = (price: number, currency: SupportedCurrency) => {
    const locale = resolveCurrencyLocale(currency);

    return formatPriceWithCurrency(
        price,
        currency,
        {
            locale,
        }
    );
};
